import React from "react";

import * as S from "./styles";

interface Props {
  classInfo: any;
  paperProps?: any;
  handleClose: () => void;
  anchorEl: any;
  id: any;
}

const SchoolClassHint = ({
  classInfo,
  paperProps,
  handleClose,
  anchorEl,
}: Props) => {
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <S.PopoverWrap
      PaperProps={paperProps}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
    >
      <S.HintWrap>
        <S.HintHeader>Klassen-Information</S.HintHeader>
        <S.HintRow>
          <S.HintItem>
            <p className="label">Lehrperson</p>
            <strong>{classInfo?.teacherName}</strong>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Max. SuS</p>
            <span>{classInfo?.maxStudentsNumber}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Min. SuS</p>
            <span>{classInfo?.minStudentsNumber}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl männlich</p>
            <span>{classInfo?.malesCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl weiblich</p>
            <span>{classInfo?.femalesCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl Teilweise erfüllt</p>
            <span>{classInfo?.knowledgeBasicCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl InS</p>
            <span>{classInfo?.insCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl DaZ</p>
            <span>{classInfo?.germanAsSecondLanguageCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl Logopadie</p>
            <span>{classInfo?.logopedicCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl Psychomotorik</p>
            <span>{classInfo?.psychomotorCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl Deutsch</p>
            <span>{classInfo?.germanCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl Mathe</p>
            <span>{classInfo?.mathsCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl LZA Deutsch</p>
            <span>{classInfo?.lzaGermanCount}</span>
          </S.HintItem>

          <S.HintItem>
            <p className="label">Anzahl LZA Mathe</p>
            <span>{classInfo?.lzaMathsCount}</span>
          </S.HintItem>
        </S.HintRow>
      </S.HintWrap>
    </S.PopoverWrap>
  );
};

export default SchoolClassHint;
